import { render, staticRenderFns } from "./text-area-comment.component.vue?vue&type=template&id=636f26cc&scoped=true&"
import script from "./text-area-comment.component.vue?vue&type=script&lang=ts&"
export * from "./text-area-comment.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-area-comment.component.vue?vue&type=style&index=0&id=636f26cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f26cc",
  null
  
)

export default component.exports